import { Mail } from "lucide-react";

const FacebookIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const InstagramIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
  </svg>
);

const SnapchatIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12.206.793c.99 0 4.347.276 5.93 3.821.529 1.193.403 3.219.299 4.847l-.003.06c-.012.18-.022.345-.03.51.075.045.203.09.401.09.3-.016.659-.12.959-.289.175-.098.354-.162.544-.162.186 0 .368.066.537.2a.844.844 0 01.346.658c.01.243-.126.476-.375.643-.18.12-.39.198-.63.27-.075.022-.154.045-.228.068-.18.06-.39.12-.57.21-.24.134-.39.33-.39.6 0 .06.008.12.022.18.24 1.11.897 2.039 1.77 2.729.21.164.449.3.69.42.18.09.36.15.48.21.21.09.39.18.495.3.15.18.18.39.12.585-.12.33-.435.54-.765.585-.375.045-.72-.015-1.035-.075-.21-.045-.42-.09-.615-.09-.12 0-.24.015-.36.06-.27.09-.45.27-.585.45-.24.315-.57.6-.945.81-.63.345-1.365.51-2.19.51-.03 0-.06-.001-.09-.001-.03.001-.06.001-.09.001-.825 0-1.56-.165-2.19-.51a3.17 3.17 0 01-.945-.81c-.135-.18-.315-.36-.585-.45a1.27 1.27 0 00-.36-.06c-.195 0-.405.045-.615.09-.315.06-.66.12-1.035.075-.33-.045-.645-.255-.765-.585-.06-.195-.03-.405.12-.585.105-.12.285-.21.495-.3.12-.06.3-.12.48-.21.24-.12.479-.255.69-.42.872-.69 1.53-1.619 1.77-2.729.015-.06.022-.12.022-.18 0-.27-.15-.465-.39-.6-.18-.09-.39-.15-.57-.21-.075-.023-.154-.046-.228-.068-.24-.072-.45-.15-.63-.27-.249-.167-.386-.4-.375-.643a.844.844 0 01.346-.658c.169-.134.351-.2.537-.2.19 0 .369.064.544.162.3.169.659.273.959.289.198 0 .326-.045.401-.09a9.203 9.203 0 01-.03-.51l-.003-.06c-.104-1.628-.23-3.654.299-4.847C7.86 1.069 11.216.793 12.206.793z"/>
  </svg>
);

const SOCIALS = [
  {
    name: "Facebook",
    icon: FacebookIcon,
    url: "https://www.facebook.com/share/18Xkm25bdA/",
    hoverColor: "hover:text-[#1877F2]",
    hoverBg: "hover:bg-[#1877F2]/10",
  },
  {
    name: "Instagram",
    icon: InstagramIcon,
    url: "https://www.instagram.com/kmsn_holding?igsh=MWp6b2o1MGx5dW15eA==",
    hoverColor: "hover:text-[#E4405F]",
    hoverBg: "hover:bg-[#E4405F]/10",
  },
  {
    name: "Snapchat",
    icon: SnapchatIcon,
    url: "https://www.snapchat.com/add/onchleuhpasnous?share_id=Q9805HZTyWA&locale=fr-FR",
    hoverColor: "hover:text-[#FFFC00]",
    hoverBg: "hover:bg-[#FFFC00]/10",
  },
  {
    name: "Email",
    icon: null,
    url: "mailto:kmsntravaux@gmail.com",
    hoverColor: "hover:text-[#C8A951]",
    hoverBg: "hover:bg-[#C8A951]/10",
  },
];

export default function SocialLinks({ direction = "row", compact = false }) {
  if (compact) {
    return (
      <div className="flex items-center gap-3" data-testid="social-links-compact">
        {SOCIALS.map((s) => (
          <a
            key={s.name}
            href={s.url}
            target={s.url.startsWith("mailto") ? "_self" : "_blank"}
            rel="noopener noreferrer"
            className={`text-[#A1A1AA] ${s.hoverColor} transition-all duration-300 hover:scale-110`}
            title={s.name}
            data-testid={`social-compact-${s.name.toLowerCase()}`}
          >
            {s.icon ? <s.icon size={16} /> : <Mail size={16} strokeWidth={1.5} />}
          </a>
        ))}
      </div>
    );
  }

  if (direction === "col") {
    return (
      <div className="flex flex-col gap-3" data-testid="social-links-col">
        {SOCIALS.map((s) => (
          <a
            key={s.name}
            href={s.url}
            target={s.url.startsWith("mailto") ? "_self" : "_blank"}
            rel="noopener noreferrer"
            className={`flex items-center gap-3 text-[#A1A1AA] ${s.hoverColor} transition-all duration-300 group`}
            data-testid={`social-${s.name.toLowerCase()}`}
          >
            <span className="group-hover:scale-110 transition-transform duration-300">
              {s.icon ? <s.icon size={18} /> : <Mail size={18} strokeWidth={1.5} />}
            </span>
            <span className="text-sm font-body">{s.name}</span>
          </a>
        ))}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-4" data-testid="social-links-row">
      {SOCIALS.map((s) => (
        <a
          key={s.name}
          href={s.url}
          target={s.url.startsWith("mailto") ? "_self" : "_blank"}
          rel="noopener noreferrer"
          className={`flex items-center gap-2 px-4 py-2 border border-white/10 ${s.hoverBg} ${s.hoverColor} text-[#A1A1AA] transition-all duration-300 group`}
          data-testid={`social-${s.name.toLowerCase()}`}
        >
          <span className="group-hover:scale-110 transition-transform duration-300">
            {s.icon ? <s.icon size={18} /> : <Mail size={18} strokeWidth={1.5} />}
          </span>
          <span className="text-sm font-body">{s.name}</span>
        </a>
      ))}
    </div>
  );
}
